module.exports = __webpack_public_path__ + "img/chevron-right-20x20-gray.346f2532.svg";